/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "../../../../default/global/js/utilities/updateClasses";
import {itemcardSubscriptions} from "../../../../default/global/js/subscriptions";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "../../../../default/global/js/iconbarHover";
import {initCustomSelects} from "../../../../default/global/js/customSelect";
import {initToggleSlide} from "../../../../default/global/js/toggle";
import {XhrService} from "../../../../default/global/ts/xhr.service";
import {appendScriptToDOM} from "../../../../default/global/js/utilities/functions";
import {initFormSubmitChanges} from "../../../../default/global/js/actionClick";
import {excludeModal, triggerModal} from "../../../../default/global/js/modal";
import {showModal} from "../../../../default/global/js/modal";
import {closeModal} from "../../../../default/global/js/modal";
import {initInputBody} from "../../../../default/global/js/inputfile";
import {focusInputGroups} from "../../../../default/global/js/checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "../../../../default/global/js/itemlistStickyOrderBar";
import {getAllQuantityInputs} from "../../../../default/global/js/quantitySpinner";
import {setAccessibilityLiveRegionMessage} from "../../../../default/global/js/accessibilityLiveRegionService";
import {triggerCopyLink} from "../../../../default/global/js/copyToClipboard";
import {getNewFlashmessage} from "../../../../default/global/js/flashmessages";
import {initCampaignOptIn} from "./campaignOptIn";

function updateBasketCount(doc) {
    for (let basketCount of document.querySelectorAll('.js-basketCount')) {
        let firstNewBasketCount = doc.querySelector('.js-basketCount');
        if (firstNewBasketCount) {
            let count = parseInt(firstNewBasketCount.innerText);
            if (isNaN(count)) {
                count = 0;
            }
            if (count === 0) {
                basketCount.style.display = "none";
            } else {
                addActionClass(basketCount, function () {
                    basketCount.style.display = "";
                });
            }
        }
    }
}

function updateItem(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-addListItemToBasket[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateOrderButtonItemcard(doc) {
    let itemcardBuybox = document.querySelector(".itemcardBuybox");
    let newItemcardBuybox = doc.querySelector('.itemcardBuybox');

    if (itemcardBuybox) {
        itemcardBuybox.innerHTML = newItemcardBuybox.innerHTML;

        itemcardSubscriptions(itemcardBuybox);
        initCustomSelects(itemcardBuybox.querySelectorAll(".js-customSelect"));
    }
}

export function updateHeaderBasket(doc) {
    let delayBasketHover = 6000;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (let headerBasket of document.querySelectorAll('.js-headerBasket')) {
        let newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            headerBasket.classList.add("showIconbarHover");
            showIconbarHover(headerBasket);
            initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));
            let basketCount = headerBasket.querySelector('.js-basketCount');

            if (basketCount) {
                addActionClass(basketCount);
            }

            setTimeout(function () {
                hideIconbarHover(headerBasket);
            }, delayBasketHover);
        }
    }
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    for (let quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        let form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    for (let spDiscount of basketView.querySelectorAll('.js-itemBasketList .spDiscount input[type="number"]')) {
        let form = spDiscount.closest(".js-itemBasketList");
        let max = spDiscount.max;
        let value = spDiscount.value;
        spDiscount.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        spDiscount.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }

}

function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    for (let spinner of basketView.querySelectorAll('.js-itemBasketList .quantity .js-spinnerUp,.js-itemBasketList .quantity .js-spinnerDown')) {
        let form = spinner.closest(".js-itemBasketList");
        spinner.addEventListener("click", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    }
}

/**
 * EU GARAN label (#231376): the basket list is replaced via innerHTML. excludeModal() moved the
 * modals of the old list to <body>, and the new triggers have no click handler yet. Remove the
 * stale modals, then bind and move the new ones the same way main.js does on page load.
 */
function rebindGaranModals(list) {
    for (const staleModal of document.querySelectorAll('body > .js-garanModal')) {
        staleModal.remove();
    }
    triggerModal(list.querySelectorAll('[data-modal]'));
    excludeModal(list.querySelectorAll('.modal:not(.modal-stay)'));
}

function updateAllBasketViews(basketView, newBasketView) {
    if (basketView && newBasketView) {
        let oldList = basketView.querySelector('.js-itemBasketList');
        let oldOrderBox = basketView.querySelector('.js-basketOrderBox');
        let oldSummary = basketView.querySelector('.js-basketSummary');
        let oldBasketPaymentButtons = basketView.querySelector('.js-basketPaymentButtons');

        let newList = newBasketView.querySelector('.js-itemBasketList');
        let newOrderBox = newBasketView.querySelector('.js-basketOrderBox');
        let newSummary = newBasketView.querySelector('.js-basketSummary');
        let newBasketPaymentButtons = newBasketView.querySelector('.js-basketPaymentButtons');

        if (newList) {
            oldList.innerHTML = newList.innerHTML;
            removeLoadingClass(oldList);
            rebindGaranModals(oldList);
            eventListenerBasketViewQuantities(basketView);
            eventListenerBasketViewQuantitySpinners(basketView);
            eventListenerBasketViewSpDiscounts(basketView);
        } else {
            basketView.innerHTML = newBasketView.innerHTML;
            return;
        }

        if (newOrderBox) {
            oldOrderBox.innerHTML = newOrderBox.innerHTML;
            removeLoadingClass(oldOrderBox);
            initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
            initFormSubmitChanges();
        }
        if (newSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
        }

        if (newBasketPaymentButtons) {
            oldBasketPaymentButtons.innerHTML = newBasketPaymentButtons.innerHTML;
            executeScripts(oldBasketPaymentButtons);
        }

        updateCampaignOptInSection(basketView, newBasketView, oldList);
    }
}

/**
 * Kampagnen-Opt-in (Feature 223237): Sektion nach jedem AJAX-Basket-Update mit dem
 * frischen Server-Zustand ersetzen (Karten wechseln je nach WKW zwischen
 * gesperrt/angeboten/gewaehlt) und serverseitige Hinweise (z. B. "Gratisartikel
 * entfernt") als Flashmessage anzeigen.
 */
function updateCampaignOptInSection(basketView, newBasketView, oldList) {
    let oldOptIn = basketView.querySelector('.js-campaignOptIn');
    let newOptIn = newBasketView.querySelector('.js-campaignOptIn');

    if (oldOptIn && newOptIn) {
        oldOptIn.outerHTML = newOptIn.outerHTML;
        initCampaignOptIn();
    } else if (oldOptIn && !newOptIn) {
        oldOptIn.remove();
    } else if (!oldOptIn && newOptIn && oldList) {
        oldList.insertAdjacentHTML('afterend', newOptIn.outerHTML);
        initCampaignOptIn();
    }

    // Flashmessages aus der Serverantwort uebernehmen (Session-Flashes wurden dort
    // bereits konsumiert und gingen sonst beim partiellen DOM-Update verloren)
    for (let flash of newBasketView.ownerDocument.querySelectorAll('#flashMessages .flashMessage')) {
        let msg = flash.querySelector('.flashMessage__msg');
        if (!msg || msg.innerText.trim() === '') {
            continue;
        }
        let type = 0;
        if (flash.classList.contains('flashMessage--success')) {
            type = 1;
        } else if (flash.classList.contains('flashMessage--warning')) {
            type = 2;
        } else if (flash.classList.contains('flashMessage--error')) {
            type = 3;
        }
        getNewFlashmessage(msg.innerText.trim(), type);
    }
}

function executeScripts(element) {
    let scripts = element.querySelectorAll('script');

    scripts.forEach(script => {
        let newScript = document.createElement('script');
        newScript.src = script.src;
        document.head.appendChild(newScript);
        newScript.remove();
    });
}

function sendBasketForm(form, basketView) {
    let formData = new FormData(form);
    addLoadingClass(basketView.querySelector('.js-itemBasketList'));
    addLoadingClass(basketView.querySelector('.js-basketOrderBox'));
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'));
        })
        .catch((e) => {
            console.error('Error:', e);
        });
}

export function checkQuantityValue(){
    let formElement=document.getElementById("itemcard_order_button_form_std");
    if(!formElement) return;
    let quantityInputElement=formElement.querySelector(".js-quantity-value");
    if(!quantityInputElement) return;
    quantityInputElement.addEventListener('input', function () {
        const max = parseFloat(quantityInputElement.max);
        const min = parseFloat(quantityInputElement.min);
        let currentValue = parseFloat(quantityInputElement.value);

        if (!isNaN(currentValue)) {
            if (!isNaN(max) && currentValue > max) {
                quantityInputElement.value = max;
            } else if (!isNaN(min) && currentValue < min) {
                quantityInputElement.value = min;
            }
        }
    });
}

export function triggerBasketBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;
        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            if (form && quantityInput) {
                if (quantityInput.value > 0) {
                    addLoadingClass(target);

                    // Check for favourites config data (wishlist hidden form)
                    const itemIdInput = form.querySelector('[name="item_id"]');
                    const itemId = itemIdInput ? itemIdInput.value : null;
                    let formData = null;
                    if (itemId) {
                        const configForm = document.querySelector('form[name="ownFavouriteItems"], form[name="sharedFavouriteItems"]');
                        if (configForm) {
                            // Resolve the hidden form index via the line number of the clicked
                            // card. The same item can be in the list several times with
                            // different configurations, so matching on the item id alone would
                            // always pick the first line - which either dropped the
                            // configuration of the clicked line or ordered a foreign one.
                            // Ticket 226351 / S26-14397.
                            const lineNo = target.closest('.itembox')?.dataset.lineNo;
                            let n = null;
                            if (lineNo && configForm.querySelector(`[name="input_item_id_${lineNo}"]`)?.value === itemId) {
                                n = lineNo;
                            } else {
                                for (const entry of configForm.querySelectorAll('[name^="input_item_id_"]')) {
                                    if (entry.value === itemId) {
                                        n = entry.name.replace('input_item_id_', '');
                                        break;
                                    }
                                }
                            }
                            if (n !== null) {
                                const savedQty = configForm.querySelector(`[name="input_item_quantity_${n}"]`)?.value;
                                formData = new FormData();
                                formData.set('action', 'shop_add_all_items_to_basket');
                                formData.set('input_item_id_1', itemId);
                                formData.set('input_item_quantity_1', savedQty || quantityInput.value);
                                const cfgId = configForm.querySelector(`[name="reorder_item_config_header_id_${n}"]`)?.value;
                                const cfgHash = configForm.querySelector(`[name="reorder_customization_hash_${n}"]`)?.value;
                                if (cfgId) formData.set('reorder_item_config_header_id_1', cfgId);
                                if (cfgHash) formData.set('reorder_customization_hash_1', cfgHash);
                            }
                        }
                    }
                    if (!formData) {
                        formData = new FormData(form);
                        formData.set('action', form.dataset.action);
                    }

                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        if (response.warningMessages && response.warningMessages.length > 0) {
                            addErrorClass(target);
                            for (const msg of response.warningMessages) {
                                getNewFlashmessage(msg, 2);
                            }
                            return response.status;
                        }
                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket && response.headerBasketContent) {
                            var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                            updateHeaderBasket(doc);
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        updateItemlistStickyOrderBarCount();
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        addSuccessClass(target);
                        if(document.body.classList.contains("basket")){
                            location.reload();
                        }
                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                            console.error('Action:', form.action);
                            console.error(formData);
                        });
                }

            }
            e.preventDefault();
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            let customizableInputValue = form.dataset.customized;
            let quantityValue = 0;
            if ((form && quantityInput) || (form && customizableInputValue === '1'))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1') {
                    addLoadingClass(target);
                    let fn = 'cart';
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    if (customizableInputValue === '1') {
                        fn = 'cartCustomize';
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        addSuccessClass(target);
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        if (fn == 'cartCustomize') {
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            if (headerBasket && response.headerBasketContent) {
                                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                        })
                        .finally(() => {
                            // The configurator disables this button on click to prevent a
                            // double add-to-basket while the request is in flight (see
                            // Configurator2D.formSubmitListener). Since this handler replaces
                            // the native submit with an AJAX call, there is no page reload to
                            // naturally reset that state, so tell the configurator to
                            // re-validate and re-enable the button once the request settles.
                            document.dispatchEvent(new CustomEvent('itemcardAddToBasketSettled', {
                                detail: {target}
                            }));
                        });
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasketHover")) {
            target = target.closest(".js-removeFromBasketHover");

            addLoadingClass(target);
            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);


            XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                addSuccessClass(target);
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                const headerBasket = document.querySelector('.js-headerBasket');
                if (headerBasket && response.headerBasketContent) {
                    var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                    updateHeaderBasket(doc);
                }
                if (response.tagManager) {
                    appendScriptToDOM(response.tagManager, true);
                }
                setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasket")) {
            target = target.closest(".js-removeFromBasket");

            let basketView = document.getElementById("userBasket");

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);

            addLoadingClass(target);

            if(basketView){
                fetch("?action=shop_remove_item_from_basket", {
                    method: "POST",
                    body: formData,
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw "Could not save data";
                        }
                        return response.text();
                    })
                    .then((data) => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(data, "text/html");
                        if(doc.querySelector(".itemBasketList")){
                            updateAllBasketViews(basketView, doc.getElementById('userBasket'));
                            updateHeaderBasket(doc,false);
                        }else{
                            location.reload();
                        }

                        dispatchCustomUpdateBasketViewsEvent({
                            data
                        });
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }else{
                formData.set('action', target.dataset.action);

                XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    addSuccessClass(target);
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }
            e.preventDefault();
        }
        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            addLoadingClass(target);

            let form = target.closest("form");
            let formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                addSuccessClass(target);
                let customizationData = response.inputDataArray;
                Object.keys(customizationData).forEach(key => {
                    let cleanKey = key.replace("input", "");
                    let customizationText = document.getElementById(cleanKey);
                    customizationText.innerHTML = customizationData[key];
                });
                form.reset();
                let existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");
            addLoadingClass(target);

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                let itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    let existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    let customizeModal = response.customizeModal;
                    let newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");
            let quantityInputs = getAllQuantityInputs();
            let forms = new Set();

            for(let qty of quantityInputs){
                let form = qty.closest("form");
                if(form){
                    forms.add(form);
                }
            }

            if (forms) {
                let formDatas = new FormData();
                for(let form of forms){
                    let qtyInput = form.querySelector('.quantity input[type="number"]');
                    if(qtyInput){
                        if(parseInt(qtyInput.value) > 0){
                            let formData = new FormData(form);
                            for (let pair of formData.entries()) {
                                formDatas.append(pair[0], pair[1]);
                            }
                        }
                    }
                }
                addLoadingClass(target);
                formDatas.set('action', 'shop_add_all_items_to_basket');

                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    for(let form of forms){
                        form.reset();
                    }
                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                        console.error(formDatas);
                    });

            }
            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAllItemPresentation")) {
            target = target.closest(".js-addListItemToBasketAllItemPresentation");

            let items_nos = document.getElementById('items_nos_added_to_basket').value;
            let formData = new FormData();
            formData.set('items_nos', items_nos);

            XhrService.generalAjaxCall(
                'add_items_to_basket',
                formData,
                'POST',
                'json').then(
                function(response){
                    if (!response.status) {
                        throw "Could not save data";
                    }

                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    addSuccessClass(target);
                    updateItemlistStickyOrderBarCount();
                    return response.status;
                }).catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
                console.error('Action:', form.action);
                console.error(formData);
            });
        }
    });
}

export function triggerUpdateBasketView() {
    let updateTimeout = false;
    let basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);
    }
}
function dispatchCustomUpdateBasketViewsEvent(data,name="updateBasketViews"){
    document.dispatchEvent(new CustomEvent(name, {
        detail: { data }
    }));
}

function openShareModal(modalId, url) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const urlText = modal.querySelector('.js-shareUrlText');
    if (urlText) urlText.value = url;

    const copyLink = modal.querySelector('.js-copyLink');
    if (copyLink) {
        copyLink.dataset.link = url;
        const freshLink = copyLink.cloneNode(true);
        freshLink.classList.remove('is-success');
        freshLink.classList.remove('is-loading');
        copyLink.parentNode.replaceChild(freshLink, copyLink);
        freshLink.addEventListener('click', function (e) {
            e.preventDefault();
            const text = freshLink.dataset.link;
            if (!text) return;
            const write = navigator.clipboard
                ? navigator.clipboard.writeText(text)
                : Promise.reject();
            write.catch(() => {
                const ta = document.createElement('textarea');
                ta.value = text;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            }).finally(() => {
                freshLink.classList.remove('is-loading');
                freshLink.classList.add('is-success');
            });
        });
    }

    showModal(modal);
}

export function initBasketWishlistShare() {
    // Share basket button
    const shareBasketBtn = document.querySelector('.js-shareBasket');
    if (shareBasketBtn) {
        shareBasketBtn.addEventListener('click', function (e) {
            e.preventDefault();
            addLoadingClass(shareBasketBtn);
            XhrService.generalAjaxCall('generate_basket_share_link', {}, 'GET', 'json').then(response => {
                removeLoadingClass(shareBasketBtn);
                if (response && response.url) {
                    openShareModal('modalBasketShare', response.url);
                }
            }).catch(() => {
                removeLoadingClass(shareBasketBtn);
                addErrorClass(shareBasketBtn);
            });
        });
    }

    // Save basket as wishlist button
    const saveAsWishlistBtn = document.querySelector('.js-saveBasketAsWishlist');
    if (saveAsWishlistBtn) {
        saveAsWishlistBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const modal = document.getElementById('modalSaveBasketAsWishlist');
            if (modal) {
                modal.dataset.mode = 'basket';
                const descInput = modal.querySelector('.js-wishlistDescription');
                if (descInput) descInput.value = '';
                showModal(modal);
            }
        });
    }

    // Confirm save basket as wishlist
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-confirmSaveBasketAsWishlist')) {
            const modal = document.getElementById('modalSaveBasketAsWishlist');
            const description = modal ? (modal.querySelector('.js-wishlistDescription')?.value || '') : '';
            const mode = modal ? modal.dataset.mode : '';
            const isSharedItemsMode = mode === 'items';

            const formData = new FormData();
            formData.append('description', description);

            if (mode === 'basket_share' && modal.dataset.shareToken) {
                formData.append('basket_share_token', modal.dataset.shareToken);
            } else if (mode === 'fav_share' && modal.dataset.shareToken) {
                formData.append('fav_share_token', modal.dataset.shareToken);
            } else if (isSharedItemsMode) {
                for (let input of document.querySelectorAll('[name^="input_item_id_"]')) {
                    const id = parseInt(input.value, 10);
                    if (id > 0) formData.append('item_ids[]', id);
                }
            }

            const fn = isSharedItemsMode || mode === 'basket_share' || mode === 'fav_share' ? 'save_items_as_wishlist' : 'save_basket_as_wishlist';
            XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                if (modal) closeModal(modal);
                if (response && response.success) {
                    const successMsg = (GLOBALS.tc && GLOBALS.tc.wishlist_created_success)
                        ? '"' + response.description + '": ' + GLOBALS.tc.wishlist_created_success
                        : 'Merkliste "' + response.description + '" wurde erfolgreich erstellt.';
                    getNewFlashmessage(successMsg, 1);
                    if (mode === '' && saveAsWishlistBtn) addSuccessClass(saveAsWishlistBtn);
                }
            }).catch(() => {
                if (mode === '' && saveAsWishlistBtn) addErrorClass(saveAsWishlistBtn);
            });
        }
    });

    // Save shared basket/wishlist items as wishlist
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-saveSharedItemsAsWishlist')) {
            e.preventDefault();
            const modal = document.getElementById('modalSaveBasketAsWishlist');
            if (modal) {
                const urlParams = new URLSearchParams(window.location.search);
                const token = urlParams.get('token') || '';
                if (urlParams.get('basket_action') === 'view_shared' && token) {
                    modal.dataset.mode = 'basket_share';
                    modal.dataset.shareToken = token;
                } else if (urlParams.get('fav_action') === 'view_shared' && token) {
                    modal.dataset.mode = 'fav_share';
                    modal.dataset.shareToken = token;
                } else {
                    modal.dataset.mode = 'items';
                    modal.dataset.shareToken = '';
                }
                const descInput = modal.querySelector('.js-wishlistDescription');
                if (descInput) descInput.value = '';
                showModal(modal);
            }
        }
    });

    // Share wishlist button
    document.addEventListener('click', function (e) {
        const shareBtn = e.target.closest('.js-shareFavourite');
        if (shareBtn) {
            e.preventDefault();
            const headerId = shareBtn.dataset.headerId;
            addLoadingClass(shareBtn);
            const formData = new FormData();
            formData.append('header_id', headerId);
            XhrService.generalAjaxCall('generate_favourite_share_link', formData, 'POST', 'json').then(response => {
                removeLoadingClass(shareBtn);
                if (response && response.url) {
                    openShareModal('modalFavouriteShare', response.url);
                }
            }).catch(() => {
                removeLoadingClass(shareBtn);
                addErrorClass(shareBtn);
            });
        }
    });

    // Add wishlist items to basket
    document.addEventListener('click', function (e) {
        const addToBasketBtn = e.target.closest('.js-addWishlistToBasket');
        if (addToBasketBtn) {
            e.preventDefault();
            const basketCount = parseInt(document.querySelector('.js-basketCount')?.innerText || '0', 10);
            if (basketCount > 0) {
                const modal = document.getElementById('modalAddWishlistToBasket');
                if (modal) {
                    modal.dataset.headerId = addToBasketBtn.dataset.headerId;
                    showModal(modal);
                }
            } else {
                addWishlistItemsToBasket(addToBasketBtn.dataset.headerId, false);
            }
        }
    });

    // Replace basket with wishlist
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-replaceBasketWithWishlist')) {
            const modal = document.getElementById('modalAddWishlistToBasket');
            const headerId = modal ? modal.dataset.headerId : null;
            if (modal) closeModal(modal);
            addWishlistItemsToBasket(headerId, true);
        }
    });

    // Add wishlist to existing basket
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-addWishlistToExistingBasket')) {
            const modal = document.getElementById('modalAddWishlistToBasket');
            const headerId = modal ? modal.dataset.headerId : null;
            if (modal) closeModal(modal);
            addWishlistItemsToBasket(headerId, false);
        }
    });

    // Add shared basket items to basket (shared basket view page)
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.js-addSharedBasketToBasket');
        if (btn) {
            e.preventDefault();
            const basketCount = parseInt(document.querySelector('.js-basketCount')?.innerText || '0', 10);
            if (basketCount > 0) {
                const modal = document.getElementById('modalAddWishlistToBasket');
                if (modal) {
                    modal.dataset.headerId = '';
                    showModal(modal);
                }
            } else {
                addWishlistItemsToBasket(null, false);
            }
        }
    });
}

function addWishlistItemsToBasket(headerId, replace) {
    const allForms = document.querySelectorAll('.js-addWishlistToBasket[data-header-id="' + headerId + '"]');
    const parentContainer = allForms.length > 0 ? allForms[0].closest('[id]') : document;

    const itemForms = (parentContainer || document).querySelectorAll('form[data-action="shop_add_all_items_to_basket"], form[name]');
    let formDatas = new FormData();

    for (let form of (parentContainer || document).querySelectorAll('form')) {
        if (form.dataset.action) continue; // skip individual item tile forms (data-action="shop_add_all_items_to_basket")
        if (form.querySelector('[name^="input_item_id_"]')) {
            let formData = new FormData(form);
            for (let pair of formData.entries()) {
                formDatas.append(pair[0], pair[1]);
            }
        }
    }
    formDatas.set('action', 'shop_add_all_items_to_basket');

    const doAdd = () => {
        XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
            if (response && response.warningMessages && response.warningMessages.length > 0) {
                for (const msg of response.warningMessages) {
                    getNewFlashmessage(msg, 2);
                }
                return;
            }
            if (response && response.headerBasketContent) {
                const doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                updateHeaderBasket(doc);
            }
        }).catch(e => console.error('addWishlistItemsToBasket error:', e));
    };

    if (replace) {
        const emptyFormData = new FormData();
        emptyFormData.set('action', 'shop_empty_user_basket');
        XhrService.generalAjaxCall('cart', emptyFormData, 'POST', 'json').then(() => {
            doAdd();
        }).catch(e => console.error('emptyBasket error:', e));
    } else {
        doAdd();
    }
}